import React from 'react';
import ArenaStreaming from '../../data/streaming/ArenaStreaming';
import GeniusStreaming from '../../data/streaming/GeniusStreaming';
import GeniusStreamingV3 from '../../data/streaming/GeniusStreamingV3';
import RadarStreaming from '../../data/streaming/RadarStreaming';
import { getArenaStreamingProps, getBetgeniusStreamingProps, getBetgeniusV3StreamingProps, getBetradarStreamingProps, isMatchArenaStreaming, isMatchBetgeniusStreaming, isMatchBetgeniusV3Streaming, isMatchBetradarStreaming } from '../../data/streaming/streamingUtils';
import { useStreaming } from './StreamingProvider';

export function isStreamingEnabled(streaming) {
    if (streaming == null || streaming.streamingId == null) {
        return false;
    }

    const streamingGenius = isMatchBetgeniusStreaming(streaming.streamingProps) && getBetgeniusStreamingProps();
    const streamingGeniusV3 = isMatchBetgeniusV3Streaming(streaming.streamingProps) && getBetgeniusV3StreamingProps();
    const streamingRadar = isMatchBetradarStreaming(streaming.streamingProps) && getBetradarStreamingProps();
    const streamingArena = isMatchArenaStreaming(streaming.streamingProps) &&  getArenaStreamingProps();
    
    return streamingGenius || streamingGeniusV3 || streamingRadar || streamingArena;
}

export default function Streaming() {
    const streaming = useStreaming();
    const streamingId = streaming.streamingId;

    if (streamingId == null) {
        return null;
    }

    const streamingMatchId = streaming.streamingMatchId;
    const streamingGenius = isMatchBetgeniusStreaming(streaming.streamingProps) && getBetgeniusStreamingProps();
    const streamingGeniusV3 = isMatchBetgeniusV3Streaming(streaming.streamingProps) && getBetgeniusV3StreamingProps();
    const streamingRadar = isMatchBetradarStreaming(streaming.streamingProps) && getBetradarStreamingProps();
    const streamingArena = isMatchArenaStreaming(streaming.streamingProps) &&  getArenaStreamingProps();
    
    return (
        <>
            <div id="streaming-container">
                {streamingRadar &&
                    <RadarStreaming matchId={streamingMatchId} streamId={streamingId} />
                }
                {streamingArena &&
                    <ArenaStreaming matchId={streamingMatchId} streamId={streamingId} />
                }
                {streamingGenius &&
                    <GeniusStreaming fid={streamingId} gci={streamingGenius[0].gci} />
                }
                {streamingGeniusV3 &&
                    <GeniusStreamingV3 fid={streamingId} confData={streamingGeniusV3[0]} />
                }
         </div>
        </>
       
    );
}
